export default class AdditionalInformation {
  constructor (data) {
    data = data || {}

    this.name = data?.name
    this.value = data?.value
  }
}
